/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import theme from '@theme';

const { colors } = theme;

export const StyledParagraphBigNumber = styled.p`
  font-size: 120px;
  color: ${colors.lightBlue};
`;
